AuthRoute = require 'mixins/authenticated-route'

App.DeliveryRoute = Em.Route.extend()